module.exports = __webpack_public_path__ + "static/img/slmPurpose3.20fd525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmPurpose3.png
// module id = gmkT
// module chunks = 2